"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StoredCardDeletionDialog = StoredCardDeletionDialog;
var _react = _interopRequireDefault(require("react"));
var _elements = require("@reservamos/elements");
var _reactI18next = require("react-i18next");
/** Confirm an irreversible stored-card deletion before sending it to the backend. */
function StoredCardDeletionDialog(_ref) {
  var card = _ref.card,
    onCancel = _ref.onCancel,
    onConfirm = _ref.onConfirm;
  var _useTranslation = (0, _reactI18next.useTranslation)('purchase'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_elements.Modal, {
    responsiveSize: "auto",
    contentHeight: "auto",
    expandedModal: true,
    defaultOpened: true,
    rounded: "M",
    removeContentPadding: true,
    showCloseButton: false,
    onCloseModal: onCancel,
    "data-sentry-element": "Modal",
    "data-sentry-component": "StoredCardDeletionDialog",
    "data-sentry-source-file": "StoredCardDeletionDialog.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-[520px] max-w-[calc(100vw-40px)] px-6 pb-6 pt-5 max-sm:w-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-between gap-4 pb-4"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "m-0 text-xl font-bold leading-tight text-gray-700"
  }, t('saved_card.delete_confirmation_title')), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "flex h-9 w-9 items-center justify-center rounded-full border-0 bg-transparent",
    "aria-label": t('saved_card.close'),
    onClick: onCancel
  }, /*#__PURE__*/_react["default"].createElement(_elements.Icon, {
    type: "Close",
    color: "primary",
    size: "S",
    "data-sentry-element": "Icon",
    "data-sentry-source-file": "StoredCardDeletionDialog.tsx"
  }))), /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "S",
    color: "grayStrong",
    "data-sentry-element": "Text",
    "data-sentry-source-file": "StoredCardDeletionDialog.tsx"
  }, t('saved_card.delete_confirmation_message', {
    last4: card.last4
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-6 flex justify-end gap-3 max-sm:flex-col-reverse"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "min-h-12 rounded-lg border border-gray-300 bg-white px-5 text-sm font-semibold text-gray-700",
    onClick: onCancel
  }, t('saved_card.delete_confirmation_cancel')), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "min-h-12 rounded-lg bg-error-strong px-5 text-sm font-semibold text-white",
    onClick: onConfirm
  }, t('saved_card.delete_confirmation_confirm')))));
}